import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import OptionColumn from "../../components/general/OptionColumn";
import SplitRows from '../../components/general/SplitRow.js';
import axios from 'axios';
import NoResult from '../../components/general/NoResult';
import GeneralHelper from '../../modules/General.js';
import General from '../../helpers/General.js';
import {Link} from "react-router";
import SplitRow from "../../components/general/SplitRow";
import moment from 'moment';

class NewsletterIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newsletters:[],
            isLoading:true,
        }
    }

    componentWillMount() {
        axios.get('/newsletters').then(res => {
            this.setState({
                newsletters:res.data,
                isLoading:false,
            })
        })
    }

    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }

    handleEdit = (id) => {
        this.props.router.push(GeneralHelper.Link('/builder/email/'+id));
    }

    renderNewsletterRow = (newsletter) => {
        return (
            <tr key={newsletter.id}>
                <td style={{textAlign:'left',width:'45%'}}>
                    <strong>{newsletter.subject}</strong>
                    {
                        newsletter.status == 1 ?
                            <span>
                                <br />
                                <i><strong>List:</strong> {newsletter.tags.SendToList}</i><br />
                                <i><strong>Sent:</strong> {moment.utc(newsletter.tags.sent).local().calendar()}</i><br />
                            </span>
                            :null
                    }
                </td>
                <td>{newsletter.status == 1 ? 'Sent':'Draft'}</td>
                <td>{newsletter.status == 1 ? newsletter.open:this.placeholder()}</td>
                <td>{newsletter.status == 1 ? newsletter.click:this.placeholder()}</td>
                <td>{newsletter.status == 1 ? newsletter.conversion:this.placeholder()}</td>
                <td>{newsletter.status == 1 ? newsletter.revenue:this.placeholder()}</td>
                <td>{newsletter.status == 1 ? newsletter.sent:this.placeholder()}</td>
                <td>{newsletter.status == 0 ?
                    <div className="btn-group" role="group">
                        <button type="button" onClick={(e) => {e.stopPropagation(); this.handleEdit(newsletter.id)}} className="btn btn-icon btn-default btn-outline"><i className="icon wb-pencil" aria-hidden="true"></i></button>
                    </div>
                    :
                    this.placeholder()}</td>
            </tr>
        )
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={false} />
            );
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-tag"></i> Newsletters</span>
                    <div className="page-header-actions">
                        <Link to={GeneralHelper.Link("/discounts/new")} className="btn btn-dark"><i className="icon fa-plus" style={{marginRight:'10px'}}></i>  New</Link>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Newsletters | Crall.io" />

                    {
                        this.state.newsletters.map((month,i) => {
                            return (
                                <div key={i}>
                                    <OptionColumn  cols={{left:2,right:10}} title={month.month} panel={false} description="Created newsletters">
                                        <table className="table outline">
                                            <thead>
                                            <tr>
                                                <th>
                                                    Subject
                                                </th>
                                                <th>
                                                    Status
                                                </th>
                                                <th>
                                                    Opens
                                                </th>
                                                <th>
                                                    Clicks
                                                </th>
                                                <th>
                                                    Conversion
                                                </th>
                                                <th>
                                                    Revenue
                                                </th>
                                                <th>
                                                    Recipients
                                                </th>
                                                <th>
                                                    Actions
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                month.newsletters.map(newsletter => {
                                                    return this.renderNewsletterRow(newsletter);
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </OptionColumn>
                                    <SplitRow/>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


NewsletterIndex = connect(mapStateToProps,mapDispatchToProps)(NewsletterIndex);
export default NewsletterIndex;



// WEBPACK FOOTER //
// ./containers/newsletters/index.js